import React, { useState, useEffect } from "react";
import DataTable from "../../../components/DataTable";
import { apiJson } from "../../../utils/api";

const DocumentRequirements = () => {
  const [docTypes, setDocTypes] = useState([]);
  const [degrees, setDegrees] = useState([]);

  useEffect(() => {
    apiJson("/api/admin/master/document-types").then(setDocTypes).catch(() => {});
    apiJson("/api/admin/master/degrees").then(setDegrees).catch(() => {});
  }, []);

  return (
    <DataTable
      title="Document Requirements"
      apiPath="/api/admin/master/document-requirements"
      columns={[
        { key: "id", label: "ID" },
        { label: "Document", render: (item) => item.documentType?.name || "-" },
        { label: "Degree", render: (item) => item.degree?.name || "All" },
        { key: "casteCategory", label: "Caste" },
        { key: "isRequired", label: "Required" },
      ]}
      formFields={[
        {
          key: "documentTypeId",
          label: "Document Type",
          type: "select",
          required: true,
          options: docTypes.map((d) => ({ value: d.id, label: d.name })),
        },
        {
          key: "degreeId",
          label: "Degree (blank = all)",
          type: "select",
          options: [{ value: "", label: "All Degrees" }, ...degrees.map((d) => ({ value: d.id, label: d.name }))],
        },
        { key: "casteCategory", label: "Caste Category (blank = all)" },
        { key: "isRequired", label: "Required", type: "checkbox", defaultValue: true },
      ]}
    />
  );
};

export default DocumentRequirements;
